import { Link } from "react-router-dom";
// import lake from "../../images/illustrations/lake.png";
import building from "../../images/illustrations/building.png";

function WelcomeSection() {

    return (
        <section className="section-colour">
            <div className="section-side-2 mobile-hide">
                {/* <img src={lake} alt="welcome" /> */}
                <img src={building} alt="welcome" />
            </div>
            <div className="section-side-1">
                <h2>Welcome</h2>
                <h4>Thank you for visiting</h4>
                <Link to={"/contact"} className="btn welcome-button">Book an Appointment</Link>
            </div>
        </section>
    );
}

export default WelcomeSection;

// https://www.youtube.com/watch?v=YOAeBSCkArA